import { cn } from '@mlm/ui';
import type { CategoryChip } from '../../lib/category-chips';

/**
 * The category row above the till grid. One line that scrolls sideways under a
 * finger, so a long menu never pushes the products down the screen.
 */
export function CategoryChips({
  chips,
  selected,
  onSelect,
}: {
  chips: CategoryChip[];
  selected: string;
  onSelect: (id: string) => void;
}) {
  if (chips.length === 0) return null;
  return (
    <div
      role="tablist"
      aria-label="Categories"
      className="-mx-1 flex gap-1 overflow-x-auto px-1 pb-1 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
    >
      {chips.map((c) => {
        const active = c.id === selected;
        return (
          <button
            key={c.id}
            type="button"
            role="tab"
            aria-selected={active}
            onClick={() => onSelect(c.id)}
            className={cn(
              'h-12 shrink-0 whitespace-nowrap rounded-[10px] px-[15px] text-base font-semibold transition-colors',
              active ? 'bg-foreground text-background' : 'text-muted-foreground',
            )}
          >
            {c.label}
          </button>
        );
      })}
    </div>
  );
}
